import { Component } from "react";
import { Form, Input, Button } from "antd";
import { CheckOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import {
  isAuthintecated,
  changePhoneNumberStatus,
  changePinCodeStatus,
  changeForgotPasswordStatus,
  getAccessRoutes,
  addPhoneNumber,
  addPassword
} from "../stores/viewsReducer/auth/actions";
import { request, postApi } from "../../../shared/src/apis";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { NotificationAlert } from '@operations/shared';
import CountryFlag from './countryFlag';

interface Props extends RouteComponentProps<any> {
  isAuthintecated: any;
  changePhoneNumberStatus: any;
  changePinCodeStatus: any;
  changeForgotPasswordStatus: any;
  phoneNumber: string;
  getAccessRoutes: any;
  request: any;
  pinCode: string;
  postApi: any;
  addPhoneNumber: any;
  addPassword: any;
}
const passwordRules = (password: string) => {
  const started = password.length > 0;
  return [
    { id: "min", label: "Minimum 8 characters", met: started && password.length >= 8 },
    { id: "max", label: "Maximum 25 characters", met: started && password.length <= 25 },
    { id: "lower", label: "At least 1 lowercase letter", met: /[a-z]/.test(password) },
    { id: "number", label: "At least 1 number", met: /[0-9]/.test(password) },
    { id: "symbol", label: "At least 1 symbol", met: /[^A-Za-z0-9]/.test(password) },
    { id: "upper", label: "At least 1 capital letter", met: /[A-Z]/.test(password) },
  ];
};

class SubmittingNewPassword extends Component<Props> {
  state = {
    btnLoader: false,
    successNotification: true,
    errorMessage: null,
    loginAgain: false,
    password: "",
  };

  onFinish = async (values: any) => {
    this.responseHandling(true, true);

    const apiBody = {
      phone: values.phoneNumber
    }
    this.responseHandling(true, true)
    const sendOtp = await this.props.postApi(`auth/send-otp`, apiBody);

    try {
      if (sendOtp.payload.status === 200) {
        this.props.changePhoneNumberStatus(true)
        this.props.addPhoneNumber(values.phoneNumber)
        this.props.addPassword(values.password)
        this.responseHandling(true, false)
      } else {
        this.responseHandling(true, false)
        this.setState({ errorMessage: sendOtp.payload.message })
      }
    } catch (error) {
      this.responseHandling(false, false)
    }
  };

  responseHandling = (successNotification: any, btnLoader: boolean) => {
    this.setState({
      successNotification: successNotification,
      btnLoader: btnLoader,
    });
  };
  onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  goLogin = () => {
    this.props.changePhoneNumberStatus(false);
    this.props.changePinCodeStatus(false);
    this.props.changeForgotPasswordStatus(false);
  };

  render() {
    const { btnLoader, successNotification, errorMessage, loginAgain, password } = this.state;
    const rules = passwordRules(password);
    return (
      <div>
        <Form
          name="basic"
          layout="vertical"
          size="large"
          requiredMark={false}
          initialValues={{ remember: true }}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Form.Item
            label="Phone number"
            name="phoneNumber"
            rules={[
              { required: true, message: 'Please enter a phone number.' },
              { pattern: /^((\+?20)|0)?1[0125]\d{8}$/, message: 'Please enter a valid phone number.', validateTrigger: 'onSubmit' },
            ]}
          >
            <Input
              prefix={<CountryFlag code="eg" />}
              placeholder="Mobile Number"
              autoComplete="tel"
              onChange={() => this.setState({ errorMessage: null })}
            />
          </Form.Item>
          <Form.Item
            label="New password"
            name="password"
            rules={[
              { required: true, message: "Please input your password!" },
              {
                pattern: new RegExp(
                  "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})"
                ),
                message: "Invalid password format!",
              },
              { min: 8, message: `Password can't be less than 8 chars` },
              { max: 25, message: `Password can't be more than 25 chars` },
            ]}
          >
            <Input.Password
              placeholder="Password"
              autoComplete="new-password"
              onChange={(event) => this.setState({ password: event.target.value })}
            />
          </Form.Item>
          <div className="password-policy" aria-live="polite">
            <p className="password-policy__title">Password requirements</p>
            <ul>
              {rules.map((rule) => (
                <li key={rule.id} className={rule.met ? "is-met" : ""}>
                  <span className="password-policy__mark" aria-hidden="true">
                    {rule.met && <CheckOutlined />}
                  </span>
                  {rule.label}
                </li>
              ))}
            </ul>
          </div>

          <Form.Item
            label="Confirm password"
            name="confirm"
            dependencies={["password"]}
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>

          {errorMessage && (
            <>
              <span style={{ float: "left", color: "#ff4d4f" }}>
                {errorMessage}
              </span>
              {loginAgain && <span style={{ float: "left", color: "#ff4d4f" }}>
                , <span style={{ color: "#ff4d4f", textDecoration: "underline", cursor: "pointer" }} onClick={this.goLogin}>login again</span>
              </span>}
              <br />
            </>
          )}
          <Button type="primary" htmlType="submit" block loading={btnLoader}>
            Change Password
          </Button>
        </Form>
        {!successNotification && (
          <NotificationAlert
            message={"Something went wrong, please try again later"}
            placement={"topLeft"}
            duration={4}
            icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
          />
        )}
      </div>
    );
  }
}

const mapStateToProp = (state: any) => ({
  phoneNumber: state.auth.phoneNumber,
  pinCode: state.auth.pinCode,
});
export default withRouter(
  connect(mapStateToProp, {
    isAuthintecated,
    changeForgotPasswordStatus,
    changePhoneNumberStatus,
    changePinCodeStatus,
    getAccessRoutes,
    request,
    postApi,
    addPhoneNumber,
    addPassword
  })(SubmittingNewPassword)
);
